import { QpMessageDialogProvider } from "./qp-message-dialog.provider";
import msgDialogTpl from "./qp-message-dialog.html";
import "./index.less";

let module_name = "qp-message-dialog";

angular.module(module_name, [])
    .provider({
        qpMessageDialog: QpMessageDialogProvider
    })
    .run(["$templateCache", function ($templateCache: angular.ITemplateCacheService) {
        $templateCache.put("qp-message-dialog.html", msgDialogTpl);
    }])

export { module_name }
